import { InventoryStatus } from '@noths/polaris-dev-ts-types';

import { isOutOfStock } from '.';

interface GetDisplayPageLoadPlacements {
  inventoryStatus: InventoryStatus;
  available: boolean;
  placementsLoaded: boolean;
  shouldShowSimilarProducts: boolean | undefined;
  similarProductsPlacementHasData: boolean;
  recentlyViewedPlacementHasData: boolean;
  activeProductsPlacementHasData: boolean;
  outOfStockPlacementHasData: boolean;
}

export const getDisplayPageLoadPlacements = ({
  inventoryStatus,
  available,
  placementsLoaded,
  shouldShowSimilarProducts,
  similarProductsPlacementHasData,
  recentlyViewedPlacementHasData,
  activeProductsPlacementHasData,
  outOfStockPlacementHasData,
}: GetDisplayPageLoadPlacements) => {
  const displaySimilarProductsPlacement =
    shouldShowSimilarProducts &&
    !isOutOfStock(inventoryStatus) &&
    available &&
    (!placementsLoaded || (placementsLoaded && similarProductsPlacementHasData));

  const displayRecentlyViewedPlacement =
    !isOutOfStock(inventoryStatus) &&
    (!placementsLoaded || (placementsLoaded && recentlyViewedPlacementHasData));

  const displayActiveProductsPlacement =
    !isOutOfStock(inventoryStatus) &&
    (!placementsLoaded || (placementsLoaded && activeProductsPlacementHasData));

  const displayOutOfStockPlacement =
    isOutOfStock(inventoryStatus) &&
    (!placementsLoaded || (placementsLoaded && outOfStockPlacementHasData));

  return {
    displaySimilarProductsPlacement,
    displayRecentlyViewedPlacement,
    displayActiveProductsPlacement,
    displayOutOfStockPlacement,
  };
};
